import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { StyledEngineProvider } from "@mui/material";
import Root from "./pages/root/root";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./assets/styles/tailwind.css";
import "./assets/styles/main.scss";
import { PermissionsProvider } from "./contexts/permissions_context";
import { SocketProvider } from "./contexts/socket_context";
import InactivityTracker from "./in_activity_tracker";
import { SnackbarProvider } from "./utilities/snackbar_provider";
import { NotificationService } from "./services/notification.service";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import queryClient from "./utilities/query_client";
import ErrorBoundary from "./components/error_boundary";

// Register & Setup Service Worker for Push Notifications
NotificationService.setupNotifications();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ErrorBoundary>
    <StyledEngineProvider injectFirst>
      <QueryClientProvider client={queryClient}>
        <PermissionsProvider>
          <SnackbarProvider>
            <SocketProvider>
              <InactivityTracker>
                <GoogleOAuthProvider clientId={process.env?.REACT_APP_GOOGLE_AUTH_CLIENT_ID || 'test'}>
                  <BrowserRouter>
                    <Root />
                  </BrowserRouter>
                </GoogleOAuthProvider>
              </InactivityTracker>
            </SocketProvider>
          </SnackbarProvider>
        </PermissionsProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </StyledEngineProvider>
  </ErrorBoundary>
);
